import { useEffect, useState } from 'react'
import { X } from 'lucide-react'

export default function Toast({ toast, onDismiss }) {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (toast) {
      // Tiny delay so the slide-up animation triggers after mount
      const t = setTimeout(() => setVisible(true), 10)
      return () => clearTimeout(t)
    } else {
      setVisible(false)
    }
  }, [toast])

  if (!toast) return null

  const typeStyles = {
    default: 'border-accent text-accent',
    error: 'border-red-500 text-red-400',
    success: 'border-accent text-accent',
    warning: 'border-accent2 text-accent2',
  }

  const style = typeStyles[toast.type] || typeStyles.default

  return (
    <div
      className={`fixed bottom-6 left-1/2 z-50 max-w-sm w-[calc(100%-2rem)] transition-all duration-300 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
      }`}
      style={{ transform: `translateX(-50%) translateY(${visible ? '0' : '1rem'})` }}
    >
      <div
        className={`flex items-start gap-3 rounded-2xl bg-surface border px-4 py-3 shadow-glow ${style}`}
        style={{ borderColor: 'inherit' }}
      >
        <p className="flex-1 text-sm font-medium text-brand-text leading-snug">
          {toast.message}
        </p>
        <button
          onClick={onDismiss}
          className="mt-0.5 text-brand-muted hover:text-brand-text transition-colors shrink-0"
          aria-label="Dismiss"
        >
          <X size={15} />
        </button>
      </div>
    </div>
  )
}
